export const environment = {
  production: false,
    urlBase: 'https://sys-archivar.com.ar/api'
    //urlBase: 'http://localhost:8082'
};
